<template>
    <div class="leave-index">
        <!-- <myBreadCrumb :urls="JSON.stringify(breadcrumbs)" @createForm="dialog.state=true" :icon="icon"></myBreadCrumb> -->
        <!-- <create-dialog v-model="dialog" @CloseDialog="closeHandler" @fetchData="fetchData"></create-dialog> -->
        <v-card class="rounded-xl elevation-3">
            <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
                Xác nhận lý do chấm công
                <v-spacer></v-spacer>

                <!-- Refresh Button -->
                <div class="d-flex align-center wrapper mx-1 my-1">
                    <v-btn @click="fetchData" outlined color="green lighten-3" class="rounded-lg" block
                        style="width: 40px !important; height: 40px; padding: 0px;">
                        <v-icon color="green darken-4">mdi-refresh</v-icon>
                    </v-btn>
                </div>

                <!-- Export Excel Button -->
                <v-btn @click="exportExcel" outlined color="teal lighten-3" class="rounded-lg ml-2"
                    style="width: 40px !important; height: 40px; padding: 0px;">
                    <v-icon color="teal darken-4">mdi-microsoft-excel</v-icon>
                </v-btn>

                <v-divider vertical class="mx-4"></v-divider>

                <!-- Actions Header Sheet (Hidden if selected empty or cannot approve) -->
                <v-btn v-if="selected.length > 0 && canApprove(selected[0])" @click="rejectDialog = true" dark color="red darken-4"
                    class="rounded-pill elevation-3 ml-4 font-weight-bold px-6">
                    <v-icon left>mdi-close-circle</v-icon> TỪ CHỐI
                </v-btn>
                <v-btn v-if="selected.length > 0 && canApprove(selected[0])" @click="confirmHandler" dark color="success"
                    class="rounded-pill elevation-3 ml-2 font-weight-bold px-6">
                    <v-icon left>mdi-check-circle</v-icon> XÁC NHẬN
                </v-btn>
            </v-card-title>

            <!-- Filters Section -->
            <v-sheet class="grey lighten-4 py-6">
                <div class="d-flex flex-wrap align-center px-6" style="gap: 12px;">
                    <div style="width: 140px;">
                        <month-picker v-model="month" label="Chọn tháng" outlined dense></month-picker>
                    </div>
                    <div style="width: 260px;">
                        <v-text-field label="Tìm kiếm chung" placeholder="Nhập từ khóa..." dense v-model="globalSearch"
                            outlined hide-details color="teal darken-4" class="white rounded-lg"></v-text-field>
                    </div>
                    <div style="width: 120px;">
                        <v-text-field label="Mã ID" placeholder="ID..." dense v-model="idSearch" outlined hide-details
                            color="teal darken-4" class="white rounded-lg"></v-text-field>
                    </div>
                    <div style="width: 140px;">
                        <v-text-field label="Mã nhân viên" placeholder="Mã NV..." dense v-model="employeeCodeSearch"
                            outlined hide-details color="teal darken-4" class="white rounded-lg"></v-text-field>
                    </div>
                    <div style="width: 200px;">
                        <v-text-field label="Tên nhân viên" placeholder="Tên NV..." dense v-model="employeeNameSearch"
                            outlined hide-details color="teal darken-4" class="white rounded-lg"></v-text-field>
                    </div>
                </div>
            </v-sheet>

            <!-- Statistics Panel -->
            <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5"
                style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
                <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
                <v-chip color="blue lighten-4" text-color="blue darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-file-document-outline</v-icon>
                    Tổng phiếu: <b class="ml-1">{{ totalCount }}</b>
                </v-chip>
                <v-chip color="orange lighten-4" text-color="orange darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-clock-outline</v-icon>
                    Chờ duyệt: <b class="ml-1">{{ pendingCount }}</b>
                </v-chip>
                <v-chip color="green lighten-4" text-color="green darken-4" class="mr-3 font-weight-medium" small>
                    <v-icon left small>mdi-check-circle-outline</v-icon>
                    Hoàn tất: <b class="ml-1">{{ confirmedCount }}</b>
                </v-chip>
                <v-chip color="red lighten-4" text-color="red darken-4" class="font-weight-medium" small>
                    <v-icon left small>mdi-close-circle-outline</v-icon>
                    Từ chối: <b class="ml-1">{{ rejectedCount }}</b>
                </v-chip>
            </v-sheet>

            <!-- Data Table -->
            <v-data-table height="600px" dense fixed-header :search="globalSearch" :mobile-breakpoint="0"
                :headers="headers" :items="items" single-select v-model="selected" :loading="isLoading"
                loading-text="Đang tải dữ liệu...">

                <!-- Table Actions -->
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex" v-if="canApprove(item)">
                        <v-btn x-small depressed rounded class="mx-1 my-1 green--text text--darken-3 font-weight-bold"
                            color="green lighten-4" @click="selected = [item]">
                            <v-icon left small>mdi-check-circle</v-icon> Duyệt
                        </v-btn>
                        <v-btn x-small depressed rounded class="mx-1 my-1 red--text text--darken-3 font-weight-bold"
                            color="red lighten-4" @click="rejectDialog = true, rejectItem = item">
                            <v-icon left small>mdi-close-circle</v-icon> Từ chối
                        </v-btn>
                    </div>
                </template>

                <!-- Table Fields Styling -->
                <template v-slot:[`item.employeeInfo`]="{ item }">
                    <div class="subtitle-2 font-weight-bold" style="line-height: 1.2;">{{ item.employeeName }}</div>
                    <div class="caption grey--text">{{ item.employeeCode }}</div>
                    <div class="caption grey--text text--darken-1" v-if="item.departmentName || item.divisionName">
                        {{ item.departmentName }} <span v-if="item.departmentName && item.divisionName">-</span> {{
                            item.divisionName }}
                    </div>
                </template>

                <template v-slot:[`item.workDate`]="{ item }">
                    <div style="line-height: 1.2;">
                        <span class="font-weight-medium text-body-2">{{ formatDate(item.workDate) }}</span>
                        <div class="caption grey--text" v-if="item.createdAt">
                            Tạo: {{ formatDate(item.createdAt) }} {{ formatTime(item.createdAt) }}
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.reason`]="{ item }">
                    <div style="line-height: 1.3;">
                        <span class="font-weight-medium text-body-2 teal--text text--darken-4">{{ item.reasonTypeName
                        }}</span>
                        <div class="caption text-truncate grey--text text--darken-2" style="max-width: 230px;"
                            v-if="item.note" :title="item.note">
                            {{ item.note }}
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.approverInfo`]="{ item }">
                    <div class="caption" style="line-height: 1.4;">
                        <!-- Quản lý trực tiếp -->
                        <div v-if="item.managerName" class="d-flex align-center">
                            <v-icon x-small
                                :color="item.confirmLevel >= 1 ? 'success' : (item.isReject && item.rejectedByCode === item.managerCode ? 'error' : 'grey')">
                                {{ item.confirmLevel >= 1 ? 'mdi-check-circle' : (item.isReject && item.rejectedByCode
                                    === item.managerCode ? 'mdi-close-circle' : 'mdi-minus-circle') }}
                            </v-icon>
                            <span class="ml-1"
                                :class="item.confirmLevel >= 1 ? 'green--text text--darken-3 font-weight-medium' : ''">QL:
                                {{ item.managerName }}</span>
                        </div>
                        <!-- Nhân sự phụ trách -->
                        <div v-if="item.hrAdminName" class="d-flex align-center">
                            <v-icon x-small
                                :color="item.confirmLevel >= 2 ? 'success' : (item.isReject && item.rejectedByCode === item.hrAdminCode ? 'error' : 'grey')">
                                {{ item.confirmLevel >= 2 ? 'mdi-check-circle' : (item.isReject && item.rejectedByCode
                                    === item.hrAdminCode ? 'mdi-close-circle' : 'mdi-minus-circle') }}
                            </v-icon>
                            <span class="ml-1"
                                :class="item.confirmLevel >= 2 ? 'green--text text--darken-3 font-weight-medium' : ''">HR:
                                {{ item.hrAdminName }}</span>
                        </div>
                        <!-- Giám đốc nhân sự (Cấp duyệt đã disabled - grey out) -->
                        <div v-if="item.hrManagerName" class="d-flex align-center grey--text" style="opacity: 0.6;">
                            <v-icon x-small color="grey">
                                mdi-minus-circle-outline
                            </v-icon>
                            <span class="ml-1 grey--text">GĐ: {{ item.hrManagerName }}</span>
                        </div>
                    </div>
                </template>

                <!-- Hover thumbnail Image column -->
                <template v-slot:[`item.imageUrl`]="{ item }">
                    <v-hover v-if="item.imageUrl" v-slot="{ hover }">
                        <v-card :elevation="hover ? 4 : 1"
                            class="transition-swing cursor-pointer rounded-lg overflow-hidden" max-width="50"
                            @click="viewUrl = item.imageUrl, selected[0] = item">
                            <v-img :src="item.imageUrl" max-width="50" height="40" cover>
                                <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                        <v-progress-circular indeterminate color="grey lighten-5"
                                            size="16"></v-progress-circular>
                                    </v-row>
                                </template>
                            </v-img>
                        </v-card>
                    </v-hover>
                    <span v-else class="grey--text caption">Không có ảnh</span>
                </template>

                <template v-slot:[`item.confirmLevel`]="{ item }">
                    <v-chip :color="getStatusColor(item)" small dark class="font-weight-medium"
                        style="width: 130px; justify-content: center;">
                        {{ getStatusText(item) }}
                    </v-chip>
                </template>


            </v-data-table>
        </v-card>

        <!-- Approval Confirmation Modal Dialog -->
        <v-dialog :value="selected.length > 0 && !viewUrl && canApprove(selected[0])" max-width="500px" v-if="selected.length > 0 && !viewUrl && canApprove(selected[0])" persistent>
            <v-card class="rounded-xl overflow-hidden elevation-5">
                <v-card-title
                    class="text-subtitle-1 font-weight-bold py-4 px-6 d-flex align-center teal darken-4 white--text"
                    style="color: white !important;">
                    Xác nhận phiếu giờ công
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="selected = []" class="white--text">
                        <v-icon color="white">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pt-6 px-6">
                    <v-row dense>
                        <v-col cols="12" class="mb-2">
                            <v-text-field outlined dense label="Mã nhân viên" readonly :value="info.employeeCode"
                                hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12" class="mb-2">
                            <v-text-field outlined dense label="Tên nhân viên" readonly :value="info.employeeName"
                                hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="6" class="mb-2">
                            <v-text-field outlined dense label="Giờ check-in" readonly :value="info.checkIn"
                                hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="6" class="mb-2">
                            <v-text-field outlined dense label="Giờ check-out" readonly :value="info.checkOut"
                                hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12" class="mb-2">
                            <v-text-field outlined dense label="Giờ công thực tế" readonly :value="info.actualTime"
                                hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12" class="mb-2">
                            <v-text-field outlined dense label="Giờ công nhân viên đề xuất" readonly
                                :value="info.wantedTime" hide-details="auto"></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" class="mb-2">
                            <v-text-field outlined dense label="Giờ công xác nhận cuối cùng"
                                v-model="info.confirmedTime" color="teal darken-4" hide-details="auto"></v-text-field>
                            <small class="error--text">Cần nhập giờ công xác nhận lại ở cấp xác nhận cuối cùng</small>
                        </v-col> -->
                        <v-col cols="12">
                            <v-textarea outlined label="Ghi chú/Bình luận" v-model="info.confirmNote"
                                color="teal darken-4" rows="3" hide-details="auto"></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pb-6 px-6 pt-2">
                    <v-spacer></v-spacer>
                    <v-btn color="teal darken-4" dark large class="rounded-pill px-6 font-weight-bold" type="button"
                        @click="confirmHandler">
                        <v-icon left>mdi-check-circle</v-icon> Xác nhận
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Proof Image Viewer Dialog -->
        <v-dialog :value="!!viewUrl" persistent fullscreen>
            <v-card dark>
                <v-card-title class="py-4 px-6 d-flex align-center">
                    Xem ảnh minh chứng
                    <v-spacer></v-spacer>
                    <v-icon @click="viewUrl = null, selected = []">mdi-close</v-icon>
                </v-card-title>
                <v-card-subtitle class="px-6 pb-4">
                    Địa điểm: {{ selected[0]?.address }}, IP: {{ selected[0] ? (selected[0]?.ipName ?? 'Không có dữ
                    liệu') :
                    'Không có dữ liệu' }}
                </v-card-subtitle>
                <v-row class="ma-0">
                    <v-col cols="12" md="8" class="pa-4">
                        <v-img :src="viewUrl" style="max-height: calc(100vh - 120px);" contain></v-img>
                    </v-col>
                    <v-col cols="12" md="4" class="pa-4">
                        <v-card style="min-height: calc(100vh - 120px);" light class="rounded-xl pa-4 elevation-3">
                            <v-card-title class="font-weight-bold text-subtitle-1 pt-0">Ghi chú xác nhận</v-card-title>
                            <v-card-text class="px-0">
                                <v-timeline dense>
                                    <v-slide-x-reverse-transition group hide-on-leave>
                                        <v-timeline-item :key="1" color="teal darken-4" small fill-dot>
                                            <v-card class="grey lighten-4 rounded-lg elevation-1">
                                                <v-card-title
                                                    class="caption font-weight-bold py-2 px-3 teal--text text--darken-4">
                                                    <v-icon small color="teal darken-4"
                                                        class="mr-2">mdi-account-tie</v-icon>
                                                    Quản lý
                                                </v-card-title>
                                                <v-card-text class="caption py-2 px-3">
                                                    {{ selected[0] ? (selected[0]?.managerNote ?? 'Không có ghi chú.') :
                                                        'Không
                                                    có ghi chú.'}}
                                                </v-card-text>
                                            </v-card>
                                        </v-timeline-item>

                                        <v-timeline-item :key="2" color="teal darken-4" small fill-dot>
                                            <v-card class="grey lighten-4 rounded-lg elevation-1">
                                                <v-card-title
                                                    class="caption font-weight-bold py-2 px-3 teal--text text--darken-4">
                                                    <v-icon small color="teal darken-4"
                                                        class="mr-2">mdi-account-cog</v-icon>
                                                    Admin HR
                                                </v-card-title>
                                                <v-card-text class="caption py-2 px-3">
                                                    {{ selected[0] ? (selected[0]?.hrAdminNote ?? 'Không có ghi chú.') :
                                                        'Không
                                                    có ghi chú.'}}
                                                </v-card-text>
                                            </v-card>
                                        </v-timeline-item>

                                        <!-- Giám đốc nhân sự (Cấp duyệt đã disabled - grey out) -->
                                        <v-timeline-item :key="3" color="grey" small fill-dot>
                                            <v-card class="grey lighten-4 rounded-lg elevation-1" style="opacity: 0.6;">
                                                <v-card-title
                                                    class="caption font-weight-bold py-2 px-3 grey--text text--darken-1 d-flex align-center">
                                                    <v-icon small color="grey"
                                                        class="mr-2">mdi-account-star</v-icon>
                                                    Giám đốc nhân sự
                                                </v-card-title>
                                                <v-card-text class="caption py-2 px-3 grey--text">
                                                    {{ selected[0] ? (selected[0]?.hrManagerNote ?? 'Không có ghi chú.')
                                                        :
                                                        'Không có ghi chú.' }}
                                                </v-card-text>
                                            </v-card>
                                        </v-timeline-item>
                                    </v-slide-x-reverse-transition>
                                </v-timeline>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>

        <!-- Rejection Note Dialog -->
        <v-dialog v-model="rejectDialog" persistent width="400px">
            <v-card class="rounded-xl">
                <v-card-title class="text-subtitle-1 font-weight-bold py-4 px-6 d-flex align-center">
                    Từ chối phiếu
                    <v-spacer></v-spacer>
                    <v-icon @click="rejectDialog = false, rejectItem = null">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="px-6 py-4">
                    <v-text-field v-model="rejectNote" dense outlined hide-details label="Lý do từ chối"
                        color="teal darken-4"></v-text-field>
                </v-card-text>
                <v-card-actions class="pb-6 justify-center">
                    <v-btn @click="rejectHandler(rejectItem)" color="teal darken-4" dark
                        class="rounded-pill px-6 font-weight-bold">
                        <v-icon left>mdi-close-circle</v-icon> Xác nhận từ chối
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import * as moment from "moment/moment";
import CreateButton from '@/components/Crud/CreateButton';
import http from '@/components/services/http-common';
import Create from '@/views/Request/EmployeeRotation/Create.vue';
import DataFilter from '@/components/DataFilter.vue';
import headers from "./header";
import { get, confirm, reject, getInfo } from "./api"

const minDate = new Date("0001-01-01T00:00:00Z");
export default {
    name: 'Leave',
    components: {
        CreateButton,
        "create-dialog": Create,
        "data-filter": DataFilter
    },
    watch: {
        tableParams: {
            handler(val) {
                // Fetch data when sorting or pagination updates
                this.fetchData();
            },
            deep: true,
        },
        filters: {
            handler(val) {
                this.tableParams.page = 1;
                // Refetch data when filters change
                this.fetchData();
            },
            deep: true,
        },
        month: {
            handler(val) {
                // Adjust filter date range based on month value changes
                this.filters.from = moment(val, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
                this.filters.to = moment(val, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
            }
        },
        selected: {
            handler(val) {
                if (val.length > 0) {
                    this.getInfo()
                }
            }
        }
    },
    data() {
        return {
            // Root API route for timesheet confirmation requests
            ROOT_URL: "TimesheetConfirmRequests/",

            // Header configuration
            icon: {
                icon: "mdi-plus-thick",
                to: ""
            },
            idSearch: null,
            employeeCodeSearch: '',
            employeeNameSearch: '',
            departmentNameSearch: '',
            divisionNameSearch: '',

            // Filter states
            month: moment().format("YYYY-MM"),
            changeArea: false,
            globalSearch: "",
            filters: {
                code: null,
                employeeName: null,
                from: moment().startOf("month").format("YYYY-MM-DD"),
                to: moment().endOf("month").format("YYYY-MM-DD"),
            },
            tableParams: {
                sortBy: [],
                sortDesc: [],
                page: 1,
            },
            selected: [],
            rowCount: 0,

            items: [],
            options: {},
            isLoading: true,

            // Dialog controllers
            dialog: {
                state: false,
                item: undefined,
            },
            confirmDialog: false,
            targetItem: {},
            viewUrl: "",
            info: {
                employeeName: "",
                checkIn: null,
                checkOut: null,
                actualTime: null,
                wantedTime: null,
                confirmedTime: null,
                confirmNote: null
            },
            rejectDialog: false,
            rejectNote: '',
            rejectItem: null
        }
    },
    computed: {
        currentUser() {
            try {
                return JSON.parse(localStorage.getItem("user"));
            } catch (e) {
                return null;
            }
        },
        currentEmployeeCode() {
            return this.currentUser ? this.currentUser.employeeCode : null;
        },
        isAdmin() {
            if (this.currentUser && (this.currentUser.isAdmin || this.currentUser.role === 'admin')) {
                return true;
            }
            const claimString = localStorage.getItem("userClaim") || '';
            const claims = claimString ? claimString.split(",") : [];
            return claims.includes("timesheet:advconfirm") ||
                claims.includes("timesheet:admin") ||
                claims.includes("super-admin") ||
                claims.includes("hr:admin");
        },
        isHrAdmin() {
            if (this.isAdmin) return true;
            const claimString = localStorage.getItem("userClaim") || '';
            const claims = claimString ? claimString.split(",") : [];
            return claims.includes("hr:admin") ||
                claims.includes("hr:dashboard") ||
                claims.includes("timesheet:advconfirm") ||
                claims.includes("timesheet:admin");
        },
        webAllowed() {
            let user = this.currentUser;
            let webAllowed = localStorage.getItem("WebAllowed");
            if (!user || !webAllowed) return false;
            return webAllowed.includes(user.employeeCode);
        },
        params: function () {
            return { ...this.tableParams, ...this.filters }
        },

        // Data table headers
        headers: function () {
            return headers(this.idSearch, this.employeeCodeSearch, this.employeeNameSearch, this.departmentNameSearch, this.divisionNameSearch)
        },

        // Statistics counters for requests
        totalCount() {
            return this.items.length;
        },
        pendingCount() {
            return this.items.filter(item => !item.isReject && item.confirmLevel < 2).length;
        },
        confirmedCount() {
            return this.items.filter(item => !item.isReject && item.confirmLevel >= 2).length;
        },
        rejectedCount() {
            return this.items.filter(item => item.isReject).length;
        }
    },

    methods: {
        // Get confirmation level CSS color code
        colorClass(value) {
            switch (value) {
                case 0: return "primary"
                case 1: return "green darken-3"
                case 2: return "red darken-3"
                default: return ""
            }
        },
        // Format ISO Date string to DD/MM/YYYY
        formatDate(value) {
            return moment(value).format("DD/MM/YYYY");
        },
        // Format ISO Date string to HH:mm:ss
        formatTime(value) {
            return moment(value).format("HH:mm:ss");
        },
        // Convert status levels to readable Vietnamese string
        getStatusText(item) {
            if (item.isReject) return "Từ chối";
            switch (item.confirmLevel) {
                case 0: return "Tạo mới";
                case 1: return "Quản lý đã duyệt";
                case 2:
                case 3: return "Hoàn tất";
                default: return "Chờ duyệt";
            }
        },
        // Map confirmation levels and rejection to Vuetify color palettes
        getStatusColor(item) {
            if (item.isReject) return "error";
            switch (item.confirmLevel) {
                case 0: return "primary";
                case 1: return "info";
                case 2:
                case 3: return "success";
                default: return "grey";
            }
        },

        // Xác định người duyệt và kiểm tra xem cấp của user hiện tại đã duyệt hay chưa
        canApprove(item) {
            if (!item || item.isReject) return false;

            // Cấp Giám đốc (level 3) đã disabled -> cấp 2 (HR đã duyệt) là cấp hoàn tất.
            // Nếu phiếu đã đạt confirmLevel >= 2 thì không còn cấp nào duyệt nữa -> ẩn actions.
            if (item.confirmLevel >= 2) return false;

            const currentCode = this.currentEmployeeCode;

            // Người tạo phiếu không thể tự duyệt phiếu của chính mình
            if (currentCode && currentCode === item.employeeCode) return false;

            // Nếu người dùng có quyền Admin / HR Admin
            if (this.isAdmin || this.isHrAdmin) {
                return item.confirmLevel < 2;
            }

            // Trường hợp người dùng là Quản lý trực tiếp (Cấp 1)
            if (currentCode && currentCode === item.managerCode) {
                // Quản lý chỉ duyệt khi phiếu đang ở cấp 0 (chưa duyệt)
                // Nếu confirmLevel >= 1 nghĩa là cấp Quản lý đã duyệt rồi -> không hiện nữa
                return item.confirmLevel === 0;
            }

            // Trường hợp người dùng là Nhân sự phụ trách (Cấp 2)
            if (currentCode && currentCode === item.hrAdminCode) {
                // HR duyệt khi Quản lý đã duyệt (confirmLevel === 1)
                // hoặc phiếu không có Quản lý trực tiếp (confirmLevel === 0)
                const canHrApprove = !item.managerCode || item.confirmLevel === 1;
                // Nếu confirmLevel >= 2 nghĩa là cấp HR đã duyệt rồi -> không hiện nữa
                return canHrApprove && item.confirmLevel < 2;
            }

            return false;
        },

        // Fetch timesheet confirmation requests
        fetchData() {
            this.isLoading = true;
            return get(this.month)
                .then(res => {
                    this.items = res.data.data;
                    this.isLoading = false;
                })
                .catch(err => {
                    console.error("Error fetching data:", err);
                    this.isLoading = false;
                });
        },
        // Export data to Excel
        exportExcel() {
            return http.get(this.ROOT_URL + "hr/export", {
                params: {
                    month: moment(this.month).format('YYYY-MM-DD')
                },
                responseType: 'blob',
            }).then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `DANH SACH_PHIEU_HT_${moment(this.month, 'yyyy-MM-dd').format("MM-YYYY")}.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
        },

        changeItemStatus(id, status) {
            return http.get(`${this.ROOT_URL}hr/change-status`, {
                params: {
                    id: id,
                    status: status
                }
            })
                .catch(() => { this.fetchData() })
        },

        // Close form dialog
        closeHandler() {
            this.dialog = { state: false, item: undefined }
        },
        editItem(item) {
            this.dialog = { state: true, item: item }
        },
        deleteItem(item) {
            this.confirmDialog = true;
            this.targetItem = item;
        },
        cfmDeleteItem() {
            http.delete(this.ROOT_URL + "undo/" + this.targetItem.id).then(res => {
                this.fetchData();
                this.confirmDialog = false;
            }).catch(err => {
                switch (err.response.status) {
                    case 403: {
                        this.unauthorizeAlert();
                        this.confirmDialog = false;
                        break;
                    }
                    default:
                        break;
                }
            })
        },

        // Process timesheet validation confirmation
        confirmHandler() {
            confirm(this.selected, this.info.confirmedTime, this.info.confirmNote).then(r => {
                console.log(r)
                this.fetchData()
                this.selected = []
            }).catch(err => {
                console.error("Confirm error:", err);
            });
        },

        // Process request rejection with notes
        rejectHandler(selected) {
            reject([selected], this.rejectNote).then(r => {
                console.log(r)
                this.rejectDialog = false;
                this.rejectItem = null;
                this.rejectNote = "";
                this.selected = []
                this.fetchData()
            }).catch(err => {
                console.error("Reject error:", err);
            });
        },

        // Load details for the validation form modal
        getInfo() {
            return getInfo(this.selected[0].id).then(r => {
                this.info = {
                    ...r.data.data,
                    checkIn: r.data.data.checkIn ? moment(r.data.data.checkIn).format("DD/MM/YYYY HH:mm:ss") : "Chưa chấm",
                    checkOut: r.data.data.checkOut ? moment(r.data.data.checkOut).format("DD/MM/YYYY HH:mm:ss") : "Chưa chấm",
                }
                console.log(this.info)
            }).catch(err => {
                console.error("GetInfo error:", err);
            });
        }
    },

    mounted() {
        this.fetchData().then(() => {
            const refId = this.$route.query.refId;
            if (refId) {
                this.idSearch = refId
            }
        })
    }
}
</script>

<style scoped></style>